import MasterService from '../../../service/MasterService';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { NavLink, Link } from 'react-router-dom';
import { API_URL } from '../../../config/constant';
import { withTranslation } from "react-i18next";
import secureStorage from '../../../config/encrypt';
import { toast } from 'react-toastify';
import { connect, useDispatch, useSelector } from "react-redux";


const Dashboard = (props) => {
  const [dashboardCards, setDashboardCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState("");
  const [searchFieldValue, setSearchFieldValue] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const logInUserInfo = secureStorage?.getItem("loginUserInfo")?.data?.user_data || {};
  const userRole = logInUserInfo?.role_data;
  const allowedRoles = [69, 61, 60, 62];
  const token=secureStorage.getItem("authToken");
  const headers={
    headers: { Authorization: token }
  };

  const isDisabled = (
    userRole.includes("master_admin") || 
    userRole.includes("admin") || 
    userRole.includes("ops_messenger")
);
  const userHasAccess = allowedRoles.includes(userRole);  

  useEffect(() => {
    getDashboardCount();
    getChatList();
  }, []);

  async function getChatList(page_num=1,filterData={}){
    setLoading(true);
    const response = await axios.post(`${API_URL.CHAT_URL}if-app/get-all-ticket`, {
        "user_id":logInUserInfo?.user_id,
        "page_num":page_num,
        "source":"web",
        "application_id": 0, 
        "name": logInUserInfo?.name,
        ...filterData,
    },headers);
    if(response?.data?.data?.length){
        setTotalCount(response?.data?.unreadCount)
    }else{
        setTotalCount(0)
    }
    setLoading(false);
}


  const getDashboardCount = async () => {
    setLoading(true);
    MasterService.post(`/dealer/inventory-funding/if_application_dashboard`).then((response) => {
      if (response && response.data && response.data.status === 200) {
        setLoading(false);
        let { data } = response.data;
        setDashboardCards(data);
      } else {
        setLoading(false);
        toast.error(response.data.message);
      }
    });
  };

  const updateReduxData = async () => {
    const loginResponse = secureStorage.getItem("loginUserInfo");
    if (!loginResponse) {
        setRedirect("/login");
        return;
    }
    props.updateStateIntoRedux("LOGIN_USER", loginResponse);
    const userRole = loginResponse?.data?.user_data?.role;
    if (userRole !== "admin") {
        setRedirect("/");
    }
  };

  useEffect(() => {
      updateReduxData();
  }, []);

  const handleChangetext = (event) => {
    setSearchFieldValue(event.target.value);
  };
  let searchUrl = '/if-application/lead-list?search_field_value=' + searchFieldValue;
  return (
    <div className="dashboard-bg">
      <div className="dashboard-outer">
        <div className="heading">
          <h1>Welcome to IF Dealer Onboarding</h1>
        </div>
        <div className="search-bx">
          <input onChange={handleChangetext} type="text" placeholder="Search by Dealer Name & Application ID" />
          <Link to={searchUrl}><button type="submit" className="search-btn">Search</button></Link>
          <i className="ic-search"></i>
        </div>
        <div className="d-flex">
          <div className="dashboard-card">
            {dashboardCards &&
              dashboardCards.map((reportList, index) => {
                const isSfaChatCard = reportList.status_name === "SFA Chat";
                if (isSfaChatCard && !isDisabled) return null;
                const cardLink = isSfaChatCard
                  ? `/if-application/sfa-chat`
                  : `/if-application/lead-list?status=${reportList.id}`;
                  
                return (
                <NavLink key={index} to={cardLink} aria-label="refinance listing page">
                  <div className={`card color-${reportList?.card_styles?.card_color_id}`}>
                    <div className="roung-bg">
                      {reportList.card_styles && (
                        <i className={reportList.card_styles.icon_className}>
                          {reportList.card_styles.max_icon_paths
                            ? Array.from(Array(reportList.card_styles.max_icon_paths).keys()).map((i, indexkey1) => (
                                <i key={indexkey1} className={`path${i + 1}`}></i>
                              ))
                            : null}
                        </i>
                      )}
                    </div>
                    <span className="count-txt">{reportList.status_name ==="SFA Chat" ? totalCount : reportList.lead_count}</span>
                    <span className="card-txt">{reportList.status_name}</span>
                  </div>
                </NavLink>
                )
               })}
          </div>
        </div>
      </div>
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
      auth_token: state.authToken,
      user_loggedin: state.userLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      updateStateIntoRedux: (actionType, stateData) => dispatch({ type: actionType, componentState: stateData }),
  };
};
export default withTranslation("if_application")(connect(mapStateToProps, mapDispatchToProps)(Dashboard));

// export default Dashboard;
